import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../../../config/config.js";

import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Button from "@mui/joy/Button";
import Input from "@mui/joy/Input";
import FormControl from "@mui/joy/FormControl";

import { useParams } from "react-router-dom";
import { toast } from "react-hot-toast";

const ModalConfigFixture = ({ open, setOpen }) => {
  const { idevent, idsport } = useParams();
  const [fixtures, setFixtures] = useState([]);

  useEffect(() => {
    const getFixture = async () => {
      const response = await axios.post(`${API_BASE_URL}/getfixture`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      setFixtures(response.data);
    };

    if (idevent && idsport) {
      getFixture();
    }
  }, [idevent, idsport]);

  const handleSaveEdit = async (idfixture, nro_team1, nro_team2) => {
    try {
      await axios.patch(`${API_BASE_URL}/updatefixture`, {
        idfixture,
        nro_team1: nro_team1 || null,
        nro_team2: nro_team2 || null,
      });
      // Refrescar los fixtures después de la actualización
      const response = await axios.post(`${API_BASE_URL}/getfixture`, {
        idevent: Number(idevent),
        idsport: Number(idsport),
      });
      setFixtures(response.data);
      toast.success("¡Fixture Actualizado Correctamente!");
    } catch (error) {
      toast.error("¡Error al Actualizar el Fixture!");
      console.error("Error al actualizar el fixture", error);
    }
  };

  const renderFixtureForTeams = (nro_equipos) => {
    const filteredFixtures = fixtures.filter(
      (fixture) => fixture.base_fixture.nro_equipos === nro_equipos
    );

    const groupedByFecha = filteredFixtures.reduce((acc, fixture) => {
      const key = fixture.n_fecha;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(fixture);
      return acc;
    }, {});

    return (
      <div key={nro_equipos}>
        <h3 className="text-xl font-medium mb-4">{nro_equipos} equipos</h3>
        {Object.keys(groupedByFecha).map((fecha, index) => (
          <div key={index} className="mb-8">
            <div className="text-lg font-semibold mb-4">Fecha {fecha}</div>
            <div className={`grid grid-cols-${nro_equipos} gap-4`}>
              {groupedByFecha[fecha].map((fixture) => (
                <div
                  key={fixture.idfixture}
                  className="bg-gray-100 p-4 rounded-lg shadow-sm flex justify-between items-center"
                >
                  <FormControl sx={{ marginRight: 1, width: "30%" }}>
                    <Input
                      value={fixture.nro_team1}
                      onChange={(e) =>
                        setFixtures((prev) =>
                          prev.map((f) =>
                            f.idfixture === fixture.idfixture
                              ? { ...f, nro_team1: e.target.value }
                              : f
                          )
                        )
                      }
                      size="sm"
                    />
                  </FormControl>
                  <span>vs</span>
                  <FormControl sx={{ marginLeft: 1, width: "30%" }}>
                    <Input
                      value={fixture.nro_team2}
                      onChange={(e) =>
                        setFixtures((prev) =>
                          prev.map((f) =>
                            f.idfixture === fixture.idfixture
                              ? { ...f, nro_team2: e.target.value }
                              : f
                          )
                        )
                      }
                      size="sm"
                    />
                  </FormControl>
                  <Button
                    onClick={() =>
                      handleSaveEdit(
                        fixture.idfixture,
                        fixture.nro_team1,
                        fixture.nro_team2
                      )
                    }
                    variant="solid"
                    size="sm"
                  >
                    Guardar
                  </Button>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <ModalDialog layout="fullscreen">
        <ModalClose sx={{ width: "35px" }} />
        <DialogTitle className="text-2xl font-bold text-gray-800">
          Configuración para Fixture
        </DialogTitle>
        <DialogContent>
          <div className="space-y-8">
            <h2 className="text-3xl font-semibold text-center mb-6">
              BASE DE FIXTURE
            </h2>

            {/* Renderizado dinámico para diferentes números de equipos */}
            {fixtures.length > 0 && renderFixtureForTeams(3)}
            {fixtures.length > 0 && renderFixtureForTeams(4)}
            {fixtures.length > 0 && renderFixtureForTeams(5)}
            {fixtures.length > 0 && renderFixtureForTeams(6)}
          </div>
        </DialogContent>
      </ModalDialog>
    </Modal>
  );
};

export default ModalConfigFixture;
